import * as SentrySDK from '@sentry/browser';
import { ContextLines, ExtraErrorData } from "@sentry/integrations";

const Sentry = {
  debug: false,
  attachStacktrace: true,

  init: (dsn, environment) => SentrySDK.init({
    dsn: dsn,
    debug: Sentry.debug,
    attachStacktrace: Sentry.attachStacktrace,
    environment: environment,
    integrations: [
      new ContextLines(),
      new ExtraErrorData(),
    ],
  }),
};

Object.freeze(Sentry);
window.Sentry = window.Sentry || Sentry;
